import { createSlice } from "@reduxjs/toolkit";
import { healthVendorCheckOrCreate } from "../CommunityAPI/communityApi";

const healthVendorCheckOrCreateSlice = createSlice({
  name: "healthVendorCheckOrCreate",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(healthVendorCheckOrCreate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(healthVendorCheckOrCreate.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(healthVendorCheckOrCreate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default healthVendorCheckOrCreateSlice.reducer;
